// Layout.jsx
import { Link, useLocation } from "react-router-dom";
import { useLang } from "../utils/LangContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import LangChange from "./LangChange";
import OngoingGameNotice from "./OngoingGameNotice";
import localStorageHelper from "../utils/localStorageHelper";

function Layout({ children }) {
  const { t } = useLang();
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const team = localStorageHelper.getItem("team");
  const game = localStorageHelper.getItem("game");
  const hasOngoingGame = Boolean(game?.hash && team?.team_code);
  const shouldShowOngoingGameNotice =
    hasOngoingGame &&
    location.pathname !== "/game" &&
    location.pathname !== "/mobile-requirements" &&
    !location.pathname.startsWith("/leaderboard");

  return (
    <div className="app-shell d-flex flex-column">
      <nav className="app-navbar navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/public-games">
            Mainor
          </Link>
          <LangChange />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              {hasOngoingGame && location.pathname !== "/game" && (
                <li className="nav-item">
                  <Link className="nav-link" to="/mobile-requirements?redirect=/game&mode=continue">
                    {t("Continue playing")}
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link className="nav-link" to="/mobile-requirements">
                  {t("Check requirements")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/public-games">
                  {t("Public Games")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  {t("Contact")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {shouldShowOngoingGameNotice && <OngoingGameNotice />}

      <main className="app-main flex-grow-1 overflow-auto p-2 position-relative">
        {children}
      </main>

      <footer className="app-footer bg-dark text-white p-3 text-center">
        &copy; {currentYear} Mainor
      </footer>
    </div>
  );
}

export default Layout;
